import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class EditableCheckbox extends React.Component {
  static defaultProps = {
    editMode: true,
    disabled: false,
  };

  static propTypes = {
    children: PropTypes.any,
    class: PropTypes.string,
    dataKey: PropTypes.any,
    disabled: PropTypes.bool,
    editMode: PropTypes.bool.isRequired,
    hideLabel: PropTypes.bool,
    label: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
    withoutHangingIndent: PropTypes.bool,
  };

  state = {
    highlighted: false,
  };

  focusHandler = () => {
    if (this.state.highlighted) {
      this.setState({
        highlighted: false,
      });
    }
  };

  handleChange = () => {
    if (!this.props.onChange) {
      return;
    }
    this.props.onChange({key: this.props.dataKey, value: !this.props.value});
  };

  highlight = () => {
    this.setState({highlighted: true});
  };

  render() {
    let content = <i className={this.props.value ? 'bl bl-checkmark' : 'bl bl-x'} />;

    if (this.props.editMode) {
      content = <div className='checkbox-wrapper'>
        <input type='checkbox'
               disabled={this.props.disabled}
               id={(this.props.dataKey ? this.props.dataKey.toString() : '').replace('.', '-')}
               checked={this.props.value}
               onChange={this.handleChange}
               data-event-category={this.props['data-event-category']}
               onFocus={this.focusHandler}
               data-event-action={this.props['data-event-action']} />
        <label />
      </div>;
    }

    let wrapperClass = 'editable-checkbox';

    if (this.props.class) {
      wrapperClass += ' ' + this.props.class;
    }

    let hangingIndent = this.props.withoutHangingIndent ?
    {
      marginLeft: -5,
    } :
    {
      paddingLeft: 35,
      textIndent: -40,
    };

    return (
      <div className={classNames(wrapperClass, {'form-control--highlighted': this.state.highlighted && this.props.editMode})}>
        <div className='form-control-static' style={this.props.editMode ? hangingIndent : {}}>
          <label className='editable-checkbox-blocklabel'>
            {content}
            {!this.props.hideLabel ?
              <span className='editable-checkbox-label' >
                {this.props.label ? this.props.label : this.props.children}
              </span> : null}
          </label>
        </div>
      </div>
    );
  }
}

export default EditableCheckbox;
